<ui-card [loading]="isLoading">
    <app-segment-header title="time-tracking.generalSettingsCardComponent.header">
        <div class="buttons">
            <ui-button type="link" [routerLink]="['./general-settings']">
                {{ 'edit' | translate }}
                <span class="sr-only">{{ 'time-tracking.generalSettingsCardComponent.header' | translate }}</span>
            </ui-button>
        </div>
    </app-segment-header>

    <div class="general-settings-content">
        <!-- weekly deadline -->
        <h3>{{ 'time-tracking.generalSettingsCardComponent.weeklyDeadline' | translate }}</h3>
        <div class="row">
            <div>{{ 'time-tracking.generalSettingsCardComponent.weeklyDeadline' | translate }}:</div>
            <div *ngIf="settings.remindersWeeklyDeadlineDayOfWeek">
                {{ 'time-tracking.generalSettingsPage.' + settings.remindersWeeklyDeadlineDayOfWeek | translate }}
                {{ 'time-tracking.generalSettingsPage.at' | translate }} {{ selectedDisplayTime }}&nbsp;<span
                    translate="time-tracking.generalSettingsPage.timeZones.{{ timeZone }}"
                ></span>
            </div>
            <div *ngIf="!settings.remindersWeeklyDeadlineDayOfWeek">{{ 'no' | translate }}</div>
        </div>

        <!-- reminders -->
        <h3>{{ 'time-tracking.generalSettingsPage.weeklyReminderTitle' | translate }}</h3>
        <div class="text-color-secondary-font" *ngIf="!settings.remindersWeeklyDeadline">
            {{ 'time-tracking.generalSettingsPage.noReminders' | translate }}
        </div>
        <ng-container *ngIf="settings.remindersWeeklyDeadline">
            <ui-card variant="outline">
                <p class="font-medium">
                    {{ 'time-tracking.generalSettingsPage.remindHelpText' | translate }}
                </p>
                <ng-container *ngFor="let approverReminder of approverReminders">
                    <div class="flex margin-bottom-2 align-items-center">
                        <ui-badge>{{ approverReminder.deadline }}</ui-badge>
                        <p
                            [innerHTML]="
                                'time-tracking.generalSettingsPage.dateAndTimeText'
                                    | translate
                                        : {
                                              dayOfWeek:
                                                  ('time-tracking.generalSettingsPage.' + approverReminder.dayOfWeek
                                                  | translate),
                                              time:
                                                  selectedDisplayTime +
                                                  ' ' +
                                                  ('time-tracking.generalSettingsPage.timeZones.' + timeZone
                                                      | translate),
                                          }
                                    | sanitizeHtml
                            "
                            class="margin-left-2 margin-bottom-0"
                        ></p>
                    </div>
                </ng-container>
            </ui-card>
            <ui-card variant="outline">
                <p class="font-medium">
                    {{ 'time-tracking.generalSettingsPage.remindEmployeeDeadline' | translate }}
                </p>
                <ng-container *ngFor="let employeeReminder of employeeReminders">
                    <div class="flex margin-bottom-2 align-items-center">
                        <ui-badge>{{ employeeReminder.deadline }}</ui-badge>
                        <p
                            [innerHTML]="
                                'time-tracking.generalSettingsPage.dateAndTimeText'
                                    | translate
                                        : {
                                              dayOfWeek:
                                                  ('time-tracking.generalSettingsPage.' + employeeReminder.dayOfWeek
                                                  | translate),
                                              time:
                                                  selectedDisplayTime +
                                                  ' ' +
                                                  ('time-tracking.generalSettingsPage.timeZones.' + timeZone
                                                      | translate),
                                          }
                                    | sanitizeHtml
                            "
                            class="margin-left-2 margin-bottom-0"
                        ></p>
                    </div>
                </ng-container>
            </ui-card>
        </ng-container>

        <!-- track future hours -->
        <h3>{{ 'time-tracking.generalSettingsCardComponent.preferences' | translate }}</h3>

        @if (hasTimeClockFlag) {
            <div class="row">
                <div>{{ 'time-tracking.generalSettingsCardComponent.timeTrackingMethod' | translate }}</div>
                <div>
                    @switch (settings.timeTrackingMethod) {
                        @case ('hours') {
                            <span>{{ 'time-tracking.generalSettingsCardComponent.trackByHours' | translate }}</span>
                            <div class="subtitle">
                                {{ 'time-tracking.generalSettingsPage.trackByHoursHint' | translate }}
                            </div>
                        }
                        @case ('start_end_time') {
                            <span>{{ 'time-tracking.generalSettingsCardComponent.trackByStartEnd' | translate }}</span>
                            <div class="subtitle">
                                {{ 'time-tracking.generalSettingsPage.trackByStartEndHint' | translate }}
                            </div>
                        }
                        @default {
                            <span>{{ 'time-tracking.generalSettingsCardComponent.trackByStartEnd' | translate }}</span>
                            <div class="subtitle">
                                {{ 'time-tracking.generalSettingsPage.trackByStartEndHint' | translate }}
                            </div>
                        }
                    }
                </div>
            </div>
        }

        @if (hasTimerClockFlag) {
            <div class="row">
                <div>{{ 'time-tracking.generalSettingsCardComponent.timeClockRounding' | translate }}</div>
                <div>
                    @switch (settings.timeClockRoundingMode) {
                        @case ('up') {
                            <span>{{
                                'time-tracking.generalSettingsCardComponent.roundingUpToNearest'
                                    | translate: { minutes: settings.timeClockRoundingMinutes }
                            }}</span>
                            <div class="subtitle">
                                {{ 'time-tracking.generalSettingsCardComponent.roundingUpToNearestHint' | translate }}
                            </div>
                        }
                        @case ('nearest') {
                            <span>{{
                                'time-tracking.generalSettingsCardComponent.roundingToNearest'
                                    | translate: { minutes: settings.timeClockRoundingMinutes }
                            }}</span>
                            <div class="subtitle">
                                {{ 'time-tracking.generalSettingsCardComponent.roundingToNearestHint' | translate }}
                            </div>
                        }
                        @default {
                            <span>{{ 'no' | translate }}</span>
                        }
                    }
                </div>
            </div>
        }

        <div class="row">
            <div>{{ 'time-tracking.generalSettingsCardComponent.trackFutureHours' | translate }}:</div>
            <div>{{ (settings.allowFutureEntries ? 'yes' : 'no') | translate }}</div>
        </div>
        <div *ngIf="settings.allowFutureEntries" class="row">
            <div>{{ 'time-tracking.generalSettingsCardComponent.futureDaysAllowed' | translate }}:</div>
            <div
                [innerHTML]="
                    'time-tracking.generalSettingsCardComponent.nextNumberDays'
                        | translate: { numberOfDays: settings.futureEntriesAllowedDays }
                "
            ></div>
        </div>
    </div>
</ui-card>
